export enum PlatformType {
    Web = "Web",
    Android = "Android",
    Iphone = "Iphone",
    PowerApps = "PowerApps"
}